import axiosInstance from "./axiosInstance";

export default class PaymentApi {

  /**
   * Delete a payment and donations
   * @param {string|number} id - Payment ID
   * @returns {Promise} - Promise with deletion result
   */
  static deletePaymentAndDonations(id) {
    return axiosInstance.delete(`/v2/payments/${id}/delete_payment_and_donations`);
  }
}